export const MuiIconStyle = {
  defaultProps: {
    baseClassName: 'modus-icons'
  }
};
//export const MuiIconStyle = {};
